import React, { PropsWithChildren } from 'react';

import { Col } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';

type CardProps = PropsWithChildren<{
  /**
   * Extra utilities, merged over the defaults below (tailwind-merge resolves
   * conflicts, so e.g. `border-2` or `px-1.5` wins over the base `border`/`p-2.5`).
   */
  className?: string;
}>;

/**
 * Bordered container with consistent styling across the application.
 *
 * @example
 * ```tsx
 * <Card>Card content here</Card>
 *
 * <Card className="border-od-border-primary p-3">Custom styled card</Card>
 * ```
 */
export const Card: React.FC<CardProps> = ({ children, className }) => {
  return (
    <Col
      className={cn(
        'rounded-lg border border-od-border-secondary bg-od-bg-secondary p-2.5',
        className,
      )}
    >
      {children}
    </Col>
  );
};
